import styled, { css } from 'styled-components';
import { Form } from 'antd';

export const WrapperIconTable = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 100%;
    height: 100%;

    .rdt_TableCell {
        width: 100%;
        justify-content: center;
    }
`;

export const TitleIconTable = styled.span`
    ${({ theme }) => css`
        color: ${theme.colors.black};
        font-size: ${theme.fontSizes.default};
    `}
`;

export const ModalContainer = styled(Form)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: start;
`;
